import type { GameUrls, UrlGame, PlayerType } from "@/shared/types/flash";
import styles from "./FlashPlayer.module.css";

interface FlashPlayerContentProps {
  mode: PlayerType | "iframe" | null;
  gameUrls: GameUrls | UrlGame | null;
  ruffleContainerRef: React.RefObject<HTMLDivElement>;
  flashContainerRef: React.RefObject<HTMLDivElement>;
  iframeContainerRef: React.RefObject<HTMLDivElement>;
}

export function FlashPlayerContent({
  mode,
  gameUrls,
  ruffleContainerRef,
  flashContainerRef,
  iframeContainerRef,
}: FlashPlayerContentProps) {
  return (
    <div className={styles.content}>
      <div
        className={`${styles.ruffleContainer} ${
          mode === "ruffle" ? styles.active : styles.hidden
        }`}
        ref={ruffleContainerRef}
      >
        {mode === "ruffle" && !gameUrls && (
          <div className={styles.fallbackContent}>
            <p>Загрузка игры...</p>
          </div>
        )}
      </div>

      <div
        className={`${styles.flashContainer} ${
          mode === "flash" ? styles.active : styles.hidden
        }`}
        ref={flashContainerRef}
      >
        {mode === "flash" && !gameUrls && (
          <div className={styles.fallbackContent}>
            <p>Загрузка Flash контента...</p>
          </div>
        )}
      </div>

      <div
        className={`${styles.iframeContainer} ${
          mode === "iframe" ? styles.active : styles.hidden
        }`}
        ref={iframeContainerRef}
      >
        {mode === "iframe" && !gameUrls && (
          <div className={styles.fallbackContent}>
            <p>Загрузка страницы...</p>
          </div>
        )}
      </div>
    </div>
  );
}
